import { trackEvent } from 'bits/analytics'

const track = () => trackEvent('Surface', 'Print Dialog')

const trackPrinting = () => {
  if (window.matchMedia) {
    let mediaQueryList = window.matchMedia('print')
    mediaQueryList.addListener(mql => {
      if (mql.matches) {
        track()
      }
    })
  }

  window.onbeforeprint = track
}

export { trackPrinting }
